var map = {
	"./frontend/AndroidGuide.vue": 7881,
	"./frontend/BetslipHistory.vue": 7181,
	"./frontend/BodyFB.vue": 2738,
	"./frontend/ContactUs.vue": 5571,
	"./frontend/DataTable.vue": 6107,
	"./frontend/Deposit.vue": 808,
	"./frontend/History.vue": 571,
	"./frontend/Home.vue": 5034,
	"./frontend/IOSGuide.vue": 7508,
	"./frontend/Iframe.vue": 2251,
	"./frontend/Index.vue": 8535,
	"./frontend/Live.vue": 7633,
	"./frontend/LiveScore.vue": 2184,
	"./frontend/MainMenu.vue": 7294,
	"./frontend/MaungFB.vue": 9034,
	"./frontend/Promotion.vue": 4685,
	"./frontend/Setting.vue": 8955,
	"./frontend/VideoLink.vue": 5923,
	"./frontend/Withdraw.vue": 5098,
	"./frontend/auth/Login.vue": 1717,
	"./frontend/auth/Rule.vue": 1777,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 3713,
	"./frontend/components/FBPreviewVoucher.vue": 2809,
	"./frontend/components/FBVoucher.vue": 9890,
	"./frontend/components/FootballTeamCard.vue": 936,
	"./frontend/components/GroupBox.vue": 8747,
	"./frontend/components/InputSelectDrawModal.vue": 313,
	"./frontend/components/LuckyWheel.vue": 187,
	"./frontend/components/NormalBox.vue": 3243,
	"./frontend/components/PreviewVoucher.vue": 5369,
	"./frontend/components/SideNav.vue": 850,
	"./frontend/components/Table.vue": 6459,
	"./frontend/components/ThreedGroupBox.vue": 5959,
	"./frontend/components/TwoDSelect.vue": 9795,
	"./frontend/components/Voucher.vue": 9780,
	"./frontend/normal-user/2d/2d.vue": 2152,
	"./frontend/normal-user/2d/ClosedDays.vue": 6899,
	"./frontend/normal-user/2d/Home.vue": 799,
	"./frontend/normal-user/2d/Winner.vue": 630,
	"./frontend/normal-user/3d/3d.vue": 3659,
	"./frontend/normal-user/3d/Home.vue": 6470,
	"./frontend/normal-user/DreamBooks.vue": 281,
	"./frontend/normal-user/Index.vue": 6012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Fishing.vue": 2416,
	"./frontend/normal-user/game/Game.vue": 1217,
	"./frontend/normal-user/game/Slot.vue": 4619,
	"./frontend/normal-user/shankomee/Room.vue": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;